export const VALID_CNAE_CODES = new Set([
  '4930-2/01',
  '4930-2/02',
  '5320-2/02',
]);

const CNAE_LABEL_KEYS = {
  '4930-2/01': 'bank_info.cnae.options.4930-2-01',
  '4930-2/02': 'bank_info.cnae.options.4930-2-02',
  '5320-2/02': 'bank_info.cnae.options.5320-2-02',
};

export const getCnaeOptions = (t) =>
  Object.entries(CNAE_LABEL_KEYS).map(([code, labelKey]) => ({
    value: code,
    label: `${code} — ${t(labelKey)}`,
  }));
